export default __webpack_public_path__ + "static/media/beardo.1b6d6a22.png";